module.exports = __webpack_public_path__ + "static/media/denmark.a78eb84c.svg";